import { useEffect, useState } from 'react';
import { isFullscreen, toggleFullscreen } from '../helpers/fullscreen';
import { useI18n } from '../i18n/I18nContext';

interface Props {
  className?: string;
}

// Icon-only fullscreen toggle. Swaps between "expand" and "compress" glyphs.
export function FullscreenButton({ className }: Props) {
  const { t } = useI18n();
  const [full, setFull] = useState(isFullscreen());

  useEffect(() => {
    const onChange = () => setFull(isFullscreen());
    document.addEventListener('fullscreenchange', onChange);
    document.addEventListener('webkitfullscreenchange', onChange);
    return () => {
      document.removeEventListener('fullscreenchange', onChange);
      document.removeEventListener('webkitfullscreenchange', onChange);
    };
  }, []);

  return (
    <button
      type="button"
      className={`fullscreen-btn ${className ?? ''}`}
      onClick={() => void toggleFullscreen()}
      title={t('common.fullscreen')}
      aria-label={t('common.fullscreen')}
    >
      <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
        {full ? (
          <path
            fill="currentColor"
            d="M9 9V4H7v3H4v2h5zm6 0h5V7h-3V4h-2v5zM9 15H4v2h3v3h2v-5zm6 0v5h2v-3h3v-2h-5z"
          />
        ) : (
          <path
            fill="currentColor"
            d="M4 9V4h5v2H6v3H4zm0 6h2v3h3v2H4v-5zm16 0v5h-5v-2h3v-3h2zM20 9h-2V6h-3V4h5v5z"
          />
        )}
      </svg>
    </button>
  );
}
